module.exports = __webpack_public_path__ + "static/musee_olympique_livre3D5-e90b8a49d62166a1a260f2ea1bd9ceb1.jpg";